<template>
    <v-container class="pa-5" fluid>
        <page-title>Zlecenia na proof</page-title>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="jobsForProof"
                        :loading="jobsForProofLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="jobsForProofData"
                        @pagination="updatePagination"
                    >
                        <template #item.number="{item}">
                            {{ item.number }}
                        </template>
                        <template #item.name="{item}">
                            {{ item.name }}
                        </template>
                        <template #item.customer="{item}">
                            <template v-if="item.customer">
                                {{ item.customer.name }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>

                        <template #item.status="{item}">
                            {{ item.status.name }}
                        </template>
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.createdBy="{item}">
                            <template v-if="item.createdBy && item.createdBy.firstName && item.createdBy.lastName">
                                {{ item.createdBy.firstName }} {{ item.createdBy.lastName }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.processStatus="{item}">
                            {{ item.processStatus }}
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            data-sentry-label="Zamknięcie zlecenia"
                                            :disabled="item.status.id === 100"
                                            v-on="on"
                                            @click="closeJob(item)"
                                        >
                                            <v-icon color="teal">
                                                mdi-cloud-download-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Zamknięcie zlecenia</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import { errorHandler } from '@/utils/errorHandler'
import pagination from '@/mixins/dataTablePagination'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

export default {
    name: 'JobsForProof',
    components: {
        PageTitle,
    },
    mixins: [
        pagination,
        dateFormatter,
        tooltipDelay,
    ],
    data() {
        return {
            headers: [
                {
                    text: 'Numer zlecenia',
                    value: 'number',
                    sortable: false
                },
                {
                    text: 'Nazwa zlecenia',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Klient',
                    value: 'customer',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'status',
                    sortable: false
                },
                {
                    text: 'Data utworzenia',
                    value: 'createdAt',
                    sortable: false
                },
                {
                    text: 'Utworzone przez',
                    value: 'createdBy',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        jobsForProof() {
            return this.$store.state.jobsForProof.jobsForProof.jobsForProof
        },
        jobsForProofLoading() {
            return this.$store.state.jobsForProof.jobsForProof.jobsForProofLoading
        },
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getJobsForProof()
    },
    methods: {
        getJobsForProof() {
            this.$store.dispatch('jobsForProof/getJobsForProof', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getJobsForProof()
            }
            this.clearPaginationPending()
        },
        closeJob(job) {
            this.$store.dispatch('jobsForProof/closeJobsForProof', {
                id: job.id,
                statusId: 100
            })
                .then(() => {
                    this.getJobsForProof()
                })
                .catch(error => {
                    errorHandler(error)
                })
        }
    }
}
</script>
